import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";

class SettingsUpdateWillMount extends Middleware implements MiddlewareInterface {
  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const selectedTabIndexSettings = this.component.props.app.settingsUpdatePageTabIndex;
    const agencySettings = this.component.props?.location?.query?.agencySettings && this.component?.props?.location?.query?.agencySettings === "true" ? true : false;

    this.component.setState({
      selectedTabIndex: agencySettings ? 1 : selectedTabIndexSettings,
      agencySettings: agencySettings
    });
  }
}

export default new SettingsUpdateWillMount();
